export const toggles = {
  constructionBuild: false,
  useLiveData: true,
}

export default toggles;